import {
  Button,
  Copy,
  Flex,
  Heading,
  Square,
  Stack,
} from '@grubhubprod/gh-cookbook-react';
import React from 'react';
import { Modal } from 'src/components/Modal/Modal';
import { useDownloadCompleteModalAnalytics } from 'src/components/selfService/features/OrderHistory/ZipDownload/hooks/DownloadCompleteModalAnalytics';

export interface IDownloadCompleteModalProps {
  onClose: () => void;
  onDownloadAgain: () => void;
}

export function DownloadCompleteModal({
  onClose,
  onDownloadAgain,
}: IDownloadCompleteModalProps): JSX.Element {
  const { sendAnalyticsBefore } = useDownloadCompleteModalAnalytics();

  return (
    <Modal size="xs">
      <Square inset="sm">
        <Stack y="sm">
          <Heading variant="h1">Download complete</Heading>
        </Stack>
        <Stack y="md" aria-label="Information">
          We’ve downloaded your receipts in a zip file to your device. If you
          don’t see the zip file, try{' '}
          <Stack
            as="span"
            onClick={() =>
              sendAnalyticsBefore(onDownloadAgain, {
                eventaction: 'complete receipts download _cta',
                eventlabel: 'try download again',
              })
            }
            style={{ cursor: 'pointer' }}
            aria-label="Download link"
          >
            <Copy variant="body" color="interactive">
              downloading again
            </Copy>
          </Stack>
          .
        </Stack>
        <Flex justifyContent="flex-end">
          <Stack width="50%">
            <Button
              block
              variant="secondary"
              buttonSize="medium"
              onClick={() =>
                sendAnalyticsBefore(onClose, {
                  eventaction: 'complete receipts download _cta',
                  eventlabel: 'ok',
                })
              }
            >
              Ok
            </Button>
          </Stack>
        </Flex>
      </Square>
    </Modal>
  );
}
